var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPopular(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.50098C8.41644 5.50098 5.50098 8.41644 5.50098 12C5.50098 15.5836 8.41644 18.499 12 18.499C15.5836 18.499 18.499 15.5836 18.499 12C18.499 8.41644 15.5836 5.50098 12 5.50098ZM15.0862 16.2482L12 15.0003L8.91379 16.2483L9.1463 12.9272L7.00631 10.3776L10.2362 9.57216L12 6.74899L13.7638 9.57212L16.9937 10.3776L14.8537 12.9272L15.0862 16.2482Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0151 10.6047L12.0002 8.98047L10.9853 10.6047L9.12744 11.0674L10.3582 12.5346L10.2249 14.4444L12.0002 13.7272L13.7755 14.4444L13.6423 12.5346L14.873 11.0674L13.0151 10.6047Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0003 1.91699C6.46198 1.91699 1.91699 6.46198 1.91699 12.0003C1.91699 17.5387 6.46198 22.0837 12.0003 22.0837C17.5387 22.0837 22.0837 17.5387 22.0837 12.0003C22.0837 6.46198 17.5387 1.91699 12.0003 1.91699ZM12.0003 19.681C7.76533 19.681 4.31966 16.2353 4.31966 12.0003C4.31966 7.76533 7.76533 4.31966 12.0003 4.31966C16.2353 4.31966 19.681 7.76533 19.681 12.0003C19.681 16.2353 16.2353 19.681 12.0003 19.681Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopular);
export default __webpack_public_path__ + "static/media/popular.c0672764.svg";
export { ForwardRef as ReactComponent };